const Users = {
  roles: {
    ADVISOR: "Advisor",
    CLIENT: "Client",
    CLIENT_PARTNER: "Client Admin",
    MANAGING_ADVISOR: "Managing Advisor",
    FULL_ACCESS_ADVISOR: "Full-access Advisor",
    ADMIN: "Admin",
    ANALYST: "Analyst",
    REVIEWER: "Reviewer",
    DEVELOPER: "Developer",
    SUPER_ADMIN: "Super Admin",
  },

  officeRoles: {
    OFFICE_MANAGER: "Office Manager"
  },

  accountTypes: {
    ESSENTIAL: "essential",
    PROFESSIONAL: "professional",
    ENTERPRISE: "enterprise",
    ENTERPRISE_SELF_PAY_REP: "enterprise_advisor",
  },

  permissions: {
    STANDARD: "Advisor",
    READ_ONLY: "Read-only Advisor",
    NO_LOGIN: "No-login Advisor",
    MANAGING: "Managing Advisor",
    FULL_ACCESS: "Full-access Advisor",
  },

  adminRoles: {
    ADMIN: "Admin",
    ANALYST: "Analyst",
    REVIEWER: "Reviewer",
    DEVELOPER: "Developer",
  },

  bulkUploadAdminRoles: {
    ADMIN: "Admin",
    ANALYST: "Analyst",
    REVIEWER: "Reviewer",
  },

  onboardingSteps: {
    KYC: "kyc",
    RECEIVE_MONEY: "receive_money",
    MAKE_PAYMENTS: "make_payments",
  },

  helpers: {
    PERMISSIONS_TOOLTIP: "<strong>Full-access Advisor:</strong> Full-access Advisors can see firm data, including other advisor's clients, and can manage billing for their own or other advisors clients.<br> \
                          <strong>Standard Advisor:</strong> Standard Access Advisors can only see their own clients, cannot control firm settings, and can only bill their own clients.<br> \
                          <strong>Read-only Advisor:</strong> Read-only Advisors have login access but can only view the status of payments and clients.<br> \
                          <strong>No-login Advisor:</strong> No-login Advisors do not have a login to view the account. This is ideal for centralized billing and assigning clients to No-login Advisors for organization. They are included at no additional cost.",
    ENTERPRISE_PERMISSIONS_TOOLTIP: "<strong>Managing Advisor:</strong> Managing Advisors can see office data, including other advisors' clients, can manage billing for their own or other advisors' clients, but cannot control office settings.<br> \
                                     <strong>Standard Advisor:</strong> Standard Access Advisors can only see their own clients, cannot control office settings, and can only bill their own clients.<br> \
                                     <strong>Read-only Advisor:</strong> Read-only Advisors have login access but can only view the status of payments and clients.<br> \
                                     <strong>No-login Advisor:</strong> No-login Advisors do not have a login to view the account. This is ideal for centralized billing and assigning clients to No-login Advisors for organization. They are included at no additional cost.",
  },

  loginSources: {
    API: "api",
    DASHBOARD: "dashboard",
    THIRD_PARTY: "third_party",
  },
  statuses: {
    ACTIVE: "active",
    INACTIVE: "inactive",
  }
}

export default Users;
